// extracted by mini-css-extract-plugin
export default {"subTitle":"EditProfile_subTitle__NJSH8","buttonsWrapper":"EditProfile_buttonsWrapper__pokZs","buttonWrapper":"EditProfile_buttonWrapper__dBZql"};